<template>
    <div class="goods">
        <v-head :title="title"></v-head>
        <div class="btns">
            <span :class="{'active' : mode == 1}" @click="changeListBtn(1)">聘任证书</span>
            <span :class="{'active' : mode == 2}" @click="changeListBtn(2)">往届聘任证书</span>
        </div>
        <div class="content">
            <van-pull-refresh v-model="Loading" @refresh="onfresh">
                <div class="list">
                    <van-list v-model="listLoading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                        <ul class="meeting_box">
                            <li v-for="(item, index) in dataList.content" :key="index" @click="goDetail(item)">
                                <span class="imgBox"><img :src="item.photoId" alt class /></span>
                                <div>
                                    <div class="line">
                                        <span class="title">聘任机构</span>
                                        <span class="fonts">{{item.branchName}}</span>
                                    </div>
                                    <div class="line">
                                        <span class="title">聘任职务</span>
                                        <span class="fonts">{{item.post}}</span>
                                    </div>
                                    <div class="line">
                                        <span class="title">届数</span>
                                        <span class="fonts">{{item.year}}</span>
                                    </div>
                                    <div class="line" v-if="mode==2">
                                        <span class="title">换届时间</span>
                                        <span class="fonts">{{item.nowElectionDate}}</span>
                                    </div>

                                </div>
                                <div style="display: flex;align-items: center;">
                                    <i style="float:right" class="el-icon-arrow-right"></i>
                                </div>


                            </li>
                        </ul>
                    </van-list>

                </div>
            </van-pull-refresh>
        </div>
    </div>
</template>

<script>
    import { Field, Button, Toast, CellGroup, List, PullRefresh, Dialog } from "vant";
    import invoiceOrder from "@/components/invoice"
    import vHead from "../../components/Subhead.vue";
    import { getOrderInfo, memberPage } from "@/api/dictionary";
    import invoiceWords from "wordsPath/invoiceWords.vue";
    export default {
        data() {
            return {
                mode: 1,
                title: "聘任证书",
                listLoading: false,
                Loading: false,
                page: 1,
                filterBox: {
                    pageSize: 10,
                    type: 1
                },
                dataList: {

                },
                navActive: 3,
                finished: false,
            };
        },
        props: ["orderType"],
        filters: {

        },
        components: {
            vHead,
            invoiceOrder,
            invoiceWords,
            [PullRefresh.name]: PullRefresh,
            [List.name]: List,
            [Dialog.name]: Dialog,

        },
        methods: {
            changeListBtn: function (value) {
                //切换已开和未开列表
                this.mode = value;
                this.filterBox.type = value;
                this.getData();
            },
            changActive(val) {
                this.navActive = val;
            },
            goDetail(item) {
                let userInfo = localStorage.getItem("userInfo")
                let expDate = new Date(userInfo.expiryDate);
                let curDate = new Date();
                sessionStorage.setItem('mode', this.mode)
                // expDate.setMonth(expDate.getMonth() - 1);
                if (userInfo.expiryDate && expDate <= curDate) {
                    Dialog.alert('您当前已过期请缴纳会费后再进行操作！', '提示', {
                        confirmButtonText: '缴纳会费',
                        type: "warning",
                        showClose: false,
                        callback: action => {
                            this.$router.push({ name: "PaymentList" });
                        }
                    });
                    return;
                } else {
                    this.$router.push({ name: "appointmentCard", query: { id: item.id } })
                }
            },
            onfresh() {
                console.log("refesh")
                this.page = 1
                var params = this.filterBox;
                params.memberId = sessionStorage.getItem("memberId")
                this.Loading = true
                memberPage(params, this.page - 1).then((res) => {
                    if (res.success) {
                        this.Loading = false;
                        this.dataList = res.result;
                        if (this.dataList.content.length >= res.result.totalElements) {
                            this.finished = true;
                        } else {
                            this.finished = false;
                        }
                    }
                });
            },
            getData: function () {
                console.log('getData')
                this.Loading = true;
                this.page = 1;
                var params = this.filterBox;
                params.memberId = sessionStorage.getItem("memberId")
                memberPage(params, this.page - 1)
                    .then(res => {
                        if (res.success) {
                            this.dataList = res.result;
                            if (this.dataList.content.length >= res.result.totalElements) {
                                this.finished = true;
                            }
                            this.Loading = false;
                            console.log('getData', this.Loading, this.listLoading)
                        } else {
                            Toast.fail(res.message);
                            this.Loading = false;
                        }
                    })
                    .catch(() => {
                        Toast.fail("获取数据失败");
                        this.Loading = false;
                    })
                    .finally(() => {
                        this.Loading = false;
                    });
                console.log('getData', this.Loading, this.listLoading)
            },
            onLoad() {
                // 异步更新数据
                if (this.page == 1) {
                    this.listLoading = false;

                    return
                }
                console.log('onLoad')
                var params = this.filterBox;
                params.memberId = sessionStorage.getItem("memberId")
                this.page = this.page + 1;
                this.listLoading = true;
                this.finished = true;
                memberPage(params, this.page - 1).then((res) => {
                    if (res.success) {
                        let meetingList = res.result.content;
                        for (let i = 0; i < meetingList.length; i++) {
                            if (!this.dataList.content) {
                                this.dataList.content.length = 0;
                            } else {
                                this.dataList.content.push(meetingList[i]);
                            }
                        }
                        this.listLoading = false;
                        if (this.dataList.content.length >= res.result.totalElements) {
                            this.finished = true;
                        }
                    }
                });

            },
        },
        computed: {
            type() {
                return this.$route.query && this.$route.query.type;
            }
        },
        watch: {

        },
        mounted() {
            if (sessionStorage.getItem('mode')) {
                this.mode = sessionStorage.getItem('mode')
                this.filterBox.type = sessionStorage.getItem('mode')
            }
            this.getData();
            sessionStorage.removeItem('mode')
        }

    }
</script>
<style lang="less" scoped>
    .goods {
        /* background-color: #efefef; */
    }

    .Payment {
        position: absolute;
        z-index: 9999;
        right: 20px;
        top: 21px;
        color: #fff;
    }

    .Order {
        background: #fafafa;
        padding: 15px 0;
        margin-top: 15px;
    }

    .Order p {
        line-height: 24px;
        color: #848484;
    }

    .fontsBox {
        width: 86%;
        margin: 20px auto 0 auto;
        background: #fff6ec;
        padding: 14px;
        font-size: 13px;
        border: #f6d0a2 dashed 1px;
        line-height: 22px;
        color: #ffbe4e;
    }

    .warmTips,
    .orderTip {
        font-size: 16px;
        text-align: center;
        margin-top: 25%;
    }

    .btns {
        display: flex;
        width: 354px;
        height: 38px;
        margin: 18px auto 16px;
        border: 1px solid #1989fa;
        text-align: center;
        justify-content: space-between;
        user-select: none;
        background-color: #fff;

        span {
            display: flex;
            width: 50%;
            height: 100%;
            font-size: 14px;
            color: #1989fa;
            cursor: pointer;
            justify-content: center;
            align-items: center;
        }

        .active {
            color: #fff;
            background: #1989fa;
        }
    }

    .content ul {
        border-top: #efefef solid 14px;
    }

    .content ul li {
        background-color: #fff;
        border-bottom: #efefef solid 14px;
        padding: 20px 5px 20px 20px;
        display: flex;
        margin: 0 4px;

        .title {
            display: inline-block;
            width: 70px;
            color: #4F4F4F;
            font-size: 12px;

        }

        .line {
            margin-bottom: 12px;
            display: flex;

        }
    }

    .meeting_box li .fonts {
        white-space: wrap;
        width: 175px;
        display: flex;
        display: inline-block;
        font-size: 13px;

    }

    .meeting_box li .imgBox {
        width: 68px;
        height: 68px;
        background: url(../../assets/images/user/图标\ 2@1x.png) center no-repeat;
        background-size: cover;
        display: flex;
        border-radius: 5px;
        margin-right: 20px;
        align-items: center;
        overflow: hidden;
    }
</style>